function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { AttrsSchema, Component, ConfigOptions, jsx } from 'panel';
import type { VNode } from 'snabbdom';
import { baseComparator } from 'common/util';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { fuzzyMatch } from 'common/util/fuzzy-match';
import { InputEl } from 'common/components/input';
import { ItemsMenuEl } from 'common/components/items-menu';
import { Section } from 'common/components/items-menu/types';
import { SegmentLiftBaselineOption } from 'common/report/util/lift/types';
import { OrderBy } from 'common/util/array';
import css from './index.inline.styl';
interface LiftBaselineMenuAttrs {
  'baseline-options': SegmentLiftBaselineOption[];
  segment: string;
}
interface LiftBaselineMenuState {
  keydownProxyEl: Node | HTMLElement;
  value: string;
}
interface LiftBaselineMenuJsxProps {
  attrs: LiftBaselineMenuAttrs;
  on?: {
    select?: (ev: CustomEvent<{
      value: SegmentLiftBaselineOption;
    }>) => void;
  };
}
export class LiftBaselineMenu extends Component<LiftBaselineMenuState, LiftBaselineMenuAttrs> {
  static get attrsSchema(): AttrsSchema<LiftBaselineMenuAttrs> {
    return _objectSpread(_objectSpread({}, super.attrsSchema), {}, {
      'baseline-options': "json",
      segment: "string"
    });
  }
  get config(): ConfigOptions<LiftBaselineMenuState> {
    return {
      defaultState: {
        value: "",
        keydownProxyEl: null
      },
      template: () => this.renderTemplate(),
      useShadowDom: true,
      css
    };
  }
  renderTemplate(): VNode {
    return <div sel='.lift-baseline-menu'>
        <InputEl attrs={{
        elref: "baseline-input",
        'auto-focus': true,
        placeholder: "Search",
        'show-clear': true,
        icon: "search"
      }} props={{
        value: this.state.value
      }} on={{
        input: ev => this.handleInputChange(ev),
        clear: () => this.update({
          value: ""
        })
      }} hook={{
        insert: ev => this.update({
          keydownProxyEl: ev.elm
        })
      }} />
        <ItemsMenuEl attrs={{
        elref: "baseline-items",
        'search-filter': this.state.value,
        sections: [{
          label: this.attr("segment"),
          items: this.getFilteredSections()
        }] as Section[]
      }} props={{
        keydownProxyEl: this.state.keydownProxyEl as HTMLElement
      }} on={{
        clickItem: ev => this.dispatchEvent(new CustomEvent("select", {
          detail: {
            value: ev.detail.value
          }
        }))
      }} />
      </div>;
  }
  getFilteredSections() {
    return this.attr("baseline-options").map(option => ({
      option,
      score: fuzzyMatch(option.displayName, this.state.value)
    })).filter(prop => prop.score).sort(baseComparator<{
      score: number;
    }, number>({
      order: OrderBy.Descending,
      transform: prop => prop.score
    })).map(baselineV => ({
      value: baselineV.option,
      label: baselineV.option.displayName
    }));
  }
  handleInputChange(ev): void {
    this.update({
      value: ev.target.value
    });
  }
}
export const LiftBaselineMenuEl = defineAndMakeJsxFactory<LiftBaselineMenuJsxProps>("mp-lift-baseline-menu", LiftBaselineMenu);
export const LiftBaselineMenuReact = panel2react<LiftBaselineMenuJsxProps>("mp-lift-baseline-menu", LiftBaselineMenu);